import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';


const fetchVesselUses = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/data/readVesselUses`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch vessel uses');
  }

  return response.json();
};


const useFetchVesselUses = () => {
  const { token } = useContext(AuthContext); 

  return useQuery('vesselUses', () => fetchVesselUses(token)); 
};

export default useFetchVesselUses;
